export const ADMINBLOG_CREATE_ACTIONS = {
  ADMINBLOG_CREATE_REQUEST: "ADMINBLOG_CREATE_REQUEST",
  ADMINBLOG_CREATE_RESPONSE: "ADMINBLOG_CREATE_RESPONSE",
  ADMINBLOG_CREATE_ERROR: "ADMINBLOG_CREATE_ERROR",
};
export const BLOG_UPDATE_ACTIONS = {
  BLOG_UPDATE_REQUEST: "BLOG_UPDATE_REQUEST",
  BLOG_UPDATE_RESPONSE: "BLOG_UPDATE_RESPONSE",
  BLOG_UPDATE_ERROR: "BLOG_UPDATE_ERROR",
};
export const BLOG_DELETE_ACTIONS = {
  BLOG_DELETE_REQUEST: "BLOG_DELETE_REQUEST",
  BLOG_DELETE_RESPONSE: "BLOG_DELETE_RESPONSE",
  BLOG_DELETE_ERROR: "BLOG_DELETE_ERROR",
};
export const GET_ALLBLOG_ACTIONS = {
  GET_ALLBLOG_REQUEST: "GET_ALLBLOG_REQUEST",
  GET_ALLBLOG_RESPONSE: "GET_ALLBLOG_RESPONSE",
  GET_ALLBLOG_ERROR: "GET_ALLBLOG_ERROR",
};
